import React from 'react';

import { EmptyCandidateFilters } from '@hooks';
import { toggle } from '@utils';
import { CandidateListGroupingOptions } from 'constants/candidates';
import { CandidateColumns } from '../columns';
import { ICandidatesControls } from '../controls';
import { CandidateSearch } from './CandidateSearch';
import { CandidateFilters } from './CandidateFilters';
import {
  CandidateFilterSections,
  offersCandidateFilterChoice,
} from './CandidateFilterSections';
import { ColumnMenu } from './ColumnMenu';
import { GroupByMenu } from './GroupByMenu';
import { ListToolbar } from './ListToolbar';
import { PositionFilterChips } from './PositionFilterChips';
import { ShowRejectedToggle } from './ShowRejectedToggle';

export const DesktopCandidatesToolbar: React.FC<ICandidatesControls> = ({
  data,
  filterOptions,
  view,
  activeFilterCount,
  isDefault,
  inactiveCount,
  onChange,
  onReset,
}) => (
  <ListToolbar
    isDefault={isDefault}
    onReset={onReset}
    search={
      <CandidateSearch
        data={data}
        value={view.query}
        onChange={(query) => onChange({ query })}
      />
    }
    filters={
      <CandidateFilters
        activeCount={activeFilterCount}
        canFilter={offersCandidateFilterChoice(filterOptions)}
        onClear={() => onChange(EmptyCandidateFilters)}
      >
        <CandidateFilterSections
          {...filterOptions}
          selectedRegions={view.regions}
          selectedSeniorities={view.seniorities}
          selectedStatuses={view.statuses}
          onChange={onChange}
        />
      </CandidateFilters>
    }
    actions={
      <>
        <ShowRejectedToggle
          checked={view.showRejected}
          count={inactiveCount}
          onChange={(showRejected) => onChange({ showRejected })}
        />

        <GroupByMenu
          options={CandidateListGroupingOptions}
          value={view.groupBy}
          onChange={(groupBy) => onChange({ groupBy })}
        />

        <ColumnMenu
          columns={CandidateColumns}
          selected={view.columns}
          onChange={(columns) => onChange({ columns })}
        />
      </>
    }
  >
    <PositionFilterChips
      positions={data}
      selectedIds={view.positionIds}
      onToggle={(id) => onChange({ positionIds: toggle(view.positionIds, id) })}
    />
  </ListToolbar>
);
